/**
 * Is a console debug switch on? — e.g. `isDebug('hopnDebug')`.
 *
 * ⚠️ READ FROM localStorage AS WELL AS window. A `window.hopnDebug = true` typed in the
 * console is gone after a reload, which is exactly when the lines worth reading (first
 * connect, first fix) print. `localStorage.hopnDebug = 1` survives it; delete the key to
 * turn it off again.
 */
export function isDebug(flag) {
    if (typeof window === 'undefined') return false
    if (window[flag]) return true
    try {
        const v = window.localStorage.getItem(flag)
        return v === '1' || v === 'true'
    } catch {
        return false
    }
}
